import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/Aboutpg.css';

import aboutVideo from '../assets/vid7.mp4';
import img1 from '../assets/building.jpg';
import img2 from '../assets/slide3.jpg';
import img3 from '../assets/pic19.jpg';
import img4 from '../assets/parralex9.avif';
import img5 from '../assets/parralex2.jpg';


const Aboutpg = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="aboutpg-container">
      <video className="background-video" autoPlay muted loop playsInline>
        <source src={aboutVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="aboutpg-content">
        <motion.div
          className="aboutpg-left"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>ABOUT US</h1>
          <p>
            We are a dedicated team providing Engineering Design, Testing And Commissioning, Mechanical HVAC Design and implementation and Civil planning And Design.
          </p>
        </motion.div>

        <motion.div
          className="aboutpg-right"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <div className="image-merge-container">
            <img className="merged-img img1" src={img1} alt="Visual 1" />
            <img className="merged-img img2" src={img2} alt="Visual 2" />
            <img className="merged-img img3" src={img3} alt="Visual 3" />
            <img className="merged-img img4" src={img4} alt="Visual 4" />
            <img className="merged-img img5" src={img5} alt="Visual 5" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Aboutpg;
